import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: { writerId: number, follow: number } = {
    writerId: 0,
    follow: -1,
};

// creating action-reducer slice
export const FollowSlice = createSlice({
    name: "follow_slice",
    initialState,
    reducers: {
        toggleFollow: (state, action: PayloadAction<{ writerId: number, follow: number }>) => {
            state.follow = action.payload.follow;
            state.writerId = action.payload.writerId;
        }
    },
});

// Action creators are generated for each case reducer function
export const { toggleFollow } = FollowSlice.actions;

export default FollowSlice.reducer;